import { useQueryClient } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { ArrowRight } from "lucide-react";
import { Logo } from "../../app/Logo";
import { api } from "../../lib/api";
import { keys } from "../../lib/queries";
import type { Me } from "../../lib/types";
import { Button } from "../../ui/Button";
import { Field, Input } from "../../ui/Form";
import styles from "./LoginPage.module.css";

export function LoginPage() {
  const client = useQueryClient();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setBusy(true);
    setError(null);
    try {
      const me = await api.post<Me>("/auth/login", { email: form.get("email"), password: form.get("password") });
      client.setQueryData(keys.me, me);
    } catch (failure) {
      setError(failure instanceof Error ? failure.message : "Gagal masuk.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className={styles.page}>
      <section className={styles.brandPanel} aria-hidden>
        <div className={styles.brandTop}>
          <Logo size={40} />
          <span>Navibiz</span>
        </div>
        <div className={styles.pitch}>
          <p className="kicker">Kenali Kami · Knowledge &amp; Ops Console</p>
          <h1>Semua chatbot klien, satu tempat.</h1>
          <ul>
            <li>Basis pengetahuan berversi dan uji terima 30 pertanyaan</li>
            <li>Pemakaian token, biaya penyedia, dan saldo per klien</li>
            <li>Pengingat saldo otomatis 30% · 10% · habis</li>
          </ul>
        </div>
        <p className={styles.legal}>PT Cetta Adika Nava · Akses internal tim Navibiz</p>
      </section>

      <main className={styles.formPanel}>
        <form className={styles.form} onSubmit={submit}>
          <div>
            <h2>Masuk</h2>
            <p className={styles.muted}>Gunakan akun tim Navibiz Anda.</p>
          </div>
          <Field label="Email">{(id) => <Input id={id} name="email" type="email" autoComplete="username" required autoFocus />}</Field>
          <Field label="Kata sandi" error={error}>
            {(id, describedBy) => <Input id={id} name="password" type="password" autoComplete="current-password" required aria-describedby={describedBy} />}
          </Field>
          <Button type="submit" variant="primary" loading={busy} icon={<ArrowRight aria-hidden />} className={styles.submit}>
            Masuk
          </Button>
        </form>
      </main>
    </div>
  );
}
